module.exports = __webpack_public_path__ + "static/media/l_dot_9.c8e00802.png";